// Where sign-in sends a person afterwards: the page they asked for, when that
// is a path on this console, otherwise the landing page. Anything that could
// leave the origin (a full URL, a protocol-relative "//host", a backslash the
// browser reads as a slash, a control character a browser drops, or a path
// that only becomes "//host" once resolved) falls back to "/". The server's
// own check (api/src/lib/next.ts) is the same rule.

// A C0 control, a space, DEL, a C1 control, or any other Unicode space.
function hasControlOrSpace(value: string): boolean {
  for (const ch of value) {
    const c = ch.codePointAt(0) ?? 0;
    if (c <= 0x20 || (c >= 0x7f && c <= 0x9f)) return true;
  }
  return /\s/u.test(value);
}

export function safeNext(next: string | undefined, origin: string): string {
  if (!next || next.length > 512 || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\') || hasControlOrSpace(next)) return '/';
  try {
    const url = new URL(next, origin);
    if (url.origin !== origin) return '/';
    // `/.//host` and `/a/..//host` resolve to the path `//host`, which as an
    // address is another site: checked after resolving.
    if (url.pathname.startsWith('//') || url.pathname.startsWith('/\\')) return '/';
    // Back to sign-in would only loop.
    if (url.pathname === '/sign-in') return '/';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/';
  }
}
